import React, { useContext } from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CustomPaginationProps } from "../../Types/types";
import { ThemeContext } from "../../hooks/themeContext";

const CustomPagination: React.FC<CustomPaginationProps> = ({
  page,
  pageCount,
  onPageChange,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { isDark } = useContext(ThemeContext);

  const paginationSettings = isSmallScreen
    ? { siblingCount: 0, boundaryCount: 1 }
    : { siblingCount: 1, boundaryCount: 2 };

  return (
    <Pagination
      count={pageCount}
      page={page}
      onChange={onPageChange}
      siblingCount={paginationSettings.siblingCount}
      boundaryCount={paginationSettings.boundaryCount}
      renderItem={(item) => (
        <PaginationItem
          components={{
            previous: ArrowBackIosIcon,
            next: ArrowForwardIosIcon,
          }}
          {...item}
          sx={{
            fontSize: isSmallScreen ? "0.75rem" : "1rem",
            minWidth: isSmallScreen ? 20 : 30,
            padding: isSmallScreen ? "6px 6px" : "8px 12px",
            "& .MuiPaginationItem-page": {
              minWidth: "auto",
            },
            "&.Mui-selected": {
              backgroundColor: "#586edf",
              borderRadius: 1,
              color: theme.palette.common.white,
            },
            "&.Mui-selected:hover": {
              backgroundColor: "#3042a0",
              color: theme.palette.common.white,
              borderRadius: 1,
            },
            "&.MuiPaginationItem-previousNext": {
              borderRadius: 1,
            },
            "&:hover": {
              backgroundColor: "#3042a0",
              color: theme.palette.common.white,
              borderRadius: 1,
            },
            borderRadius: 1,
            color: isDark ? "#fff" : "#000",
          }}
        />
      )}
    />
  );
};

export default CustomPagination;
